export default __webpack_public_path__ + "static/media/select-icon.b7b384a4.svg";